// "Just arrived" badge helpers
//
// A product is considered new for 14 days after Shopify's `publishedAt`
// (falling back to `createdAt`). We keep the threshold here so it's tunable
// in one place — bump to 7 / 21 days as the catalogue cadence changes.

const NEW_DAYS = 10;

export function isJustArrived(node: {
  publishedAt?: string | null;
  createdAt?: string | null;
}): boolean {
  // Prefer createdAt — it's set once when the product is first created and
  // never moves. publishedAt updates every time a product is re-published
  // (edits, channel changes, hide/show), so old products kept showing up
  // as "Lige landet" long after they actually arrived.
  const ts = node.createdAt ?? node.publishedAt;
  if (!ts) return false;
  const t = Date.parse(ts);
  if (isNaN(t)) return false;
  const ageDays = (Date.now() - t) / (1000 * 60 * 60 * 24);
  return ageDays >= 0 && ageDays <= NEW_DAYS;
}

export const JUST_ARRIVED_DAYS = NEW_DAYS;
